import { gql } from '@apollo/client';
import { useRef } from 'react';

import { queryClient, useQuery } from '@fhs/client';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';

import { GetGiftCardBalancePayload, TransferInquiryInput } from '../utils/types';

export const TransferInquiryQuery = gql`
  query TransferInquiry($input: TransferInquiryInput) @gateway @authRequired {
    transferInquiry(input: $input) {
      giftCard {
        currentBalance
      }
    }
  }
`;

const QUERY_KEY = 'getBalance';

export const useGiftCardTransferInquiryQuery = ({
  cardNumber,
  pin,
  fetchBalance = true,
}: TransferInquiryInput & { fetchBalance?: boolean }) => {
  const queryKey = [QUERY_KEY, cardNumber, pin ];
  const prevFetchBalance = useRef(false);

  // Clear cache when fetchBalance transitions from false to true
  // This is to avoid cached results from previous balance checks
  if (fetchBalance && !prevFetchBalance.current) {
    queryClient.removeQueries({ queryKey });
  }
  prevFetchBalance.current = fetchBalance;

  return useQuery({
    enabled: fetchBalance,
    queryKey,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    queryFn: async () => {
      const { data } = await client.query({
        query: TransferInquiryQuery,
        fetchPolicy: 'no-cache',
        variables: {
          input: {
            cardNumber,
            pin,
          },
        },
      });
      return data?.transferInquiry?.giftCard as GetGiftCardBalancePayload;
    },
  });
};
